import React from 'react';
import './WeatherGraph.css';

import {
  get12HourTimeHour,
  get12HourPeriod,
} from '../../utils/datetime';

const graphBottomOffset = 60;
const graphSideOffset = 30;
const graphTopOffset = 60;

const propTypes = {
  height: React.PropTypes.number.isRequired,
  width: React.PropTypes.number.isRequired,
  points: React.PropTypes.arrayOf(React.PropTypes.shape({
    temperature: React.PropTypes.number.isRequired,
    time: React.PropTypes.object.isRequired,
  })).isRequired,
}

const deviation = function(temp, allPoints) {
  const sortedData = allPoints.concat().sort((a, b) => a.temperature - b.temperature);
  const min = sortedData[0].temperature;
  const max = sortedData[sortedData.length - 1].temperature;

  return (temp - min) / (max - min);
}

const getPointCoords = function(allPoints, index, graphWidth, graphHeight) {
  return {
    x: ((graphWidth - (graphSideOffset * 2)) / allPoints.length) * (index + (index / (allPoints.length - 1))) + graphSideOffset,
    y: (graphHeight - graphBottomOffset) - deviation(allPoints[index].temperature, allPoints) * (graphHeight - graphBottomOffset - graphTopOffset),
  }
}

const getLineData = function(points, graphWidth, graphHeight) {
  const primaryPoints = points.map((point, index) => {
    return getPointCoords(points, index, graphWidth, graphHeight);
  });

  const startPoint = {
    x: 0,
    y: primaryPoints[0].y,
  };

  const endPoint = {
    x: graphWidth,
    y: primaryPoints[primaryPoints.length - 1].y,
  };

  const closeLoopPoints = [{
    x: graphWidth,
    y: graphHeight,
  }, {
    x: 0,
    y: graphHeight,
  }]

  return [].concat(
    startPoint,
    primaryPoints,
    endPoint,
    closeLoopPoints,
    startPoint,
  ).map((coords, index) => {
    if (index === 0) {
      return `M ${coords.x} ${coords.y}`;
    }
    return `L ${coords.x} ${coords.y}`;
  }).join(' ');
}

const getTempPointCoords = function (points, index, graphWidth, graphHeight) {
  const coords = getPointCoords(points, index, graphWidth, graphHeight);
  return {
    x: coords.x,
    y: coords.y - 20,
  }
}

const getTimePointCoords = function (points, index, graphWidth, graphHeight) {
  const coords = getPointCoords(points, index, graphWidth, graphHeight);
  return {
    x: coords.x,
    y: coords.y + 30,
  }
}

const WeatherGraph = props => (
  <svg
    className='weather-graph'
    width={props.width}
    height={props.height}
    viewBox={`0 0 ${props.width} ${props.height}`}
    xmlns='http://www.w3.org/2000/svg'
    fontSize='10px'
    fontFamily='Lato'>
    <path className='weather-graph__graph' d={getLineData(props.points, props.width, props.height)} />
    {props.points.map((point, index) => (
      <g
        key={point.time.valueOf()}
        onClick={props.onChange}>
        <text
          className='weather-graph__temp'
          textAnchor='middle'
          {...getTempPointCoords(props.points, index, props.width, props.height)}>
          {point.temperature}
        </text>
        <text
          className='weather-graph__time'
          textAnchor='middle'
          {...getTimePointCoords(props.points, index, props.width, props.height)}>
          {`${get12HourTimeHour(point.time)}${get12HourPeriod(point.time)}`}
        </text>
      </g>
    ))}
  </svg>
)

WeatherGraph.propTypes = propTypes;

export default WeatherGraph;



// WEBPACK FOOTER //
// ./src/components/WeatherGraph/WeatherGraph.js